// extracted by mini-css-extract-plugin
module.exports = {"button":"_8KMHAYZH07","large":"_1KUkUGkKj_","busy":"_1AYgYv4FgT","naked":"nvoVmWO8E8","disabled":"_35juxVdyb1","raw":"_1lRccPOeoC","danger":"_110ycmGZi-","warning":"_2jknicNcJQ","secondary":"_3ATZR-JyQP","error":"_2yStWpFWy6","shake":"_3MOJSsk9mp","with-icon":"_1jbE9D8alg","withIcon":"_1jbE9D8alg","only-icon":"_27EQVXxk-h","onlyIcon":"_27EQVXxk-h","content":"_3YAFRyuUcw","spinner":"qGLYPDX9pb"};
    if(module.hot) {
      // 1614934685887
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  